import { useEffect, useSyncExternalStore, type ReactNode } from "react"

/**
 * A render slot above the active thread's composer on the full-page Sofia
 * surface: an ephemeral card that is not part of the transcript (the "save
 * this chat as a notebook" prompt). Owned by whichever page is showing the
 * thread, since app-covi cannot import the modules that fill it.
 *
 * One slot, last writer wins, cleared on unmount.
 */
let accessory: ReactNode = null
const listeners = new Set<() => void>()

function emit(): void {
  for (const listener of listeners) {
    listener()
  }
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const getSnapshot = (): ReactNode => accessory
const getServerSnapshot = (): ReactNode => null

export function useSofiaThreadFooterAccessory(): ReactNode {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}

export function useSetSofiaThreadFooterAccessory(node: ReactNode): void {
  useEffect(() => {
    accessory = node
    emit()
    return () => {
      if (accessory === node) {
        accessory = null
        emit()
      }
    }
  }, [node])
}
